/**
 * Syncs ccdr pagination dots with horizontal product slides in the cart drawer.
 */
(function () {
  const DRAWER_ID = 'Cart-Drawer';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function bindCcdr(host) {
    const slides = host.querySelector('.ccdr__slides');
    const dots = host.querySelectorAll('.ccdr__dot');
    const pagination = host.querySelector('.ccdr__pagination');
    if (!slides || !dots.length || !pagination) return;

    let raf = null;

    /**
     * Keeps the active dot in the pagination viewport. Uses getBoundingClientRect
     * (not offsetLeft) so flex + gap layouts measure correctly; centers the dot
     * in the strip when possible, clamps to scroll range, then nudges if still clipped.
     */
    function scrollPaginationToActiveDot(activeDot) {
      if (!activeDot || !pagination) return;

      const maxScroll = Math.max(0, pagination.scrollWidth - pagination.clientWidth);

      const step = () => {
        const pagRect = pagination.getBoundingClientRect();
        const dotRect = activeDot.getBoundingClientRect();
        const dotCenterX = dotRect.left + dotRect.width / 2;
        const pagCenterX = pagRect.left + pagination.clientWidth / 2;
        let target = pagination.scrollLeft + (dotCenterX - pagCenterX);
        target = Math.max(0, Math.min(maxScroll, Math.round(target)));
        pagination.scrollLeft = target;
      };

      step();

      requestAnimationFrame(() => {
        step();
        const pad = 4;
        const p = pagination.getBoundingClientRect();
        const d = activeDot.getBoundingClientRect();
        let left = pagination.scrollLeft;
        if (d.left < p.left + pad) {
          left -= p.left + pad - d.left;
        } else if (d.right > p.right - pad) {
          left += d.right - (p.right - pad);
        }
        left = Math.max(0, Math.min(maxScroll, Math.round(left)));
        if (left !== pagination.scrollLeft) {
          pagination.scrollLeft = left;
        }
      });
    }

    function setActive(index) {
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('ccdr__dot--active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      const activeDot = dots[index];
      requestAnimationFrame(() => {
        requestAnimationFrame(() => scrollPaginationToActiveDot(activeDot));
      });
    }

    function slideIndexFromScroll() {
      const slideEls = host.querySelectorAll('.ccdr__slide');
      if (!slideEls.length) return 0;
      const left = slides.scrollLeft;
      let best = 0;
      let bestDist = Infinity;
      slideEls.forEach((slide, i) => {
        const dist = Math.abs(slide.offsetLeft - left);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }

    function onScroll() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        raf = null;
        setActive(slideIndexFromScroll());
      });
    }

    slides.addEventListener('scroll', onScroll, { passive: true });

    if ('onscrollend' in window) {
      slides.addEventListener(
        'scrollend',
        () => {
          setActive(slideIndexFromScroll());
        },
        { passive: true }
      );
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.getAttribute('data-ccdr-index'), 10);
        const slideEls = host.querySelectorAll('.ccdr__slide');
        const target = slideEls[idx];
        if (!target) return;
        slides.scrollTo({
          left: target.offsetLeft,
          behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        });
        setActive(idx);
      });
    });

    setActive(0);
  }

  function scan(root) {
    if (!root) return;
    root.querySelectorAll('.ccdr--cart-mobile .ccdr__host').forEach((el) => {
      const container = el.querySelector('.ccdr__container');
      if (!container || container.hasAttribute('data-ccdr-handled')) return;
      container.setAttribute('data-ccdr-handled', '');
      bindCcdr(el);
    });
  }

  const drawer = document.getElementById(DRAWER_ID);
  if (!drawer) return;

  scan(drawer);

  const mo = new MutationObserver(() => scan(drawer));
  mo.observe(drawer, { childList: true, subtree: true });
})();
